import Vue from 'vue'
import VueRouter from 'vue-router'
const home = () => import('@/views/home.vue');
const introduction = () => import('@/views/company/introduction.vue');
const history = () => import('@/views/company/history.vue');
const event = () => import('@/views/company/event.vue');
const concept = () => import('@/views/culture/concept.vue');
const solar = () => import('@/views/culture/solar.vue');
const business = () => import('@/views/business/business.vue');
const policy = () => import('@/views/sustainability/policy.vue');
const application = () => import('@/views/sustainability/application.vue');
const contribution = () => import('@/views/sustainability/contribution.vue');
const technology = () => import('@/views/business/technology.vue');
const textile = () => import('@/views/business/textile.vue');
const map = () => import('@/views/map.vue');
const contact = () => import('@/views/contact.vue');
const material = () => import('@/views/business/material.vue');

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/company-introduction',
    name: 'CompanyIntroduction',
    component: introduction
  },
  {
    path: '/company-history',
    name: 'CompanyHistory',
    component: history
  },
  {
    path: '/company-event',
    name: 'CompanyEvent',
    component: event
  },
  {
    path: '/culture-concept',
    name: 'CultureConcept',
    component: concept
  },
  {
    path: '/culture-solar',
    name: 'CultureSolar',
    component: solar
  },
  {
    path: '/business',
    name: 'Business',
    component: business
  },
  {
    path: '/textile',
    name: 'Textile',
    component: textile
  },
  {
    path: '/material',
    name: 'Material',
    component: material
  },
  {
    path: '/technology',
    name: 'Technology',
    component: technology
  },
  {
    path: '/policy',
    name: 'Policy',
    component: policy
  },
  {
    path: '/application',
    name: 'Application',
    component: application
  },
  {
    path: '/contribution',
    name: 'Contribution',
    component: contribution
  },
  {
    path: '/map',
    name: 'Map',
    component: map
  },
  {
    path: '/contact',
    name: 'Contact',
    component: contact
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
